<template>
    <div class="nav-container">
        <span class="resaneh-link" :class="{ 'active': type == 'all'}" @click="changeType('all')">همه</span>
        <span class="resaneh-link" :class="{ 'active': type == 'top-six'}" @click="changeType('top-six')">جدیدترین‌ها</span>
        <span class="resaneh-link" :class="{ 'active': type == 'favorites'}" @click="changeType('favorites')">محبوب‌ترین‌ها</span>
    </div>
</template>

<script>
export default {
    name: 'ResanehNav',
    props: ['type'],
    methods: {
        changeType(type) {
            this.$emit('changeType', type)
        }
    }
}
</script>

<style scoped>
.nav-container {
    height: 35pt;
    width: calc(100vw - 18vh);

    margin: auto;
}
.nav-container .resaneh-link {
    width: 33.33%;
    /* width: 50%; */
    height: 100%;
    margin: auto;

    color: #86888e;
  
    text-align: center;
    font-weight: bold;
    display: inline-block;
    padding: 0 !important;
    padding-top: .3rem !important;
    border-top: 3px solid #ebecf1;
}
.nav-container .resaneh-link.active,
.nav-container .resaneh-link:active,
.nav-container .resaneh-link:hover {
    color: #373b48;
    border-top: 3px solid #ed412c;
}

@media (max-width: 576px) {
    .nav-container .resaneh-link {
        font-size: .7rem;
        padding-top: .5rem !important;
    }
}
</style>

